import { ComponentThemeProps } from "@insite/mobius/globals/baseTheme";

const SelectPresentationPropsDefault: ComponentThemeProps["select"]["defaultProps"] = {
    iconProps: { src: "ChevronDown" },
};

export default SelectPresentationPropsDefault;
